import { SxProps } from "@mui/material";

export const testimonialStyles = {
  container: {
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  } as SxProps,

  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  } as SxProps,

  emptyState: {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px",
    } as SxProps,
    image: {
      width: "107px",
      height: "80px",
    },
    text: {
      color: "var(--Dark---1000, #111)",
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "20px",
    } as SxProps,
  },

  card: {
    container: {
      borderRadius: "8px",
      overflow: "hidden",
    },
    content: {
      padding: "16px",
      border: "1px solid #EAECF0",
      borderRadius: "8px 8px 0 0",
      background: "#FFF",
      display: "flex",
      flexDirection: "column",
    },

    header: {
      container: {
        display: "flex",
        justifyContent: "space-between",
      },
      avatarContainer: {
        display: "flex",
        gap: "8px",
      },
      userInfo: {
        display: "flex",
        flexDirection: "column",
      },
      userName: {
        color: "var(--Dark---1000, #111)",
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "24px",
        textDecoration: "unset",
        cursor: "pointer",
      },
      userMeta: {
        color: "var(--Dark---600, #707070)",
        fontFamily: "Montserrat",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "18px",
      },
    },

    body: {
      container: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      },
      reviewText: {
        color: "var(--Dark---1000, #111)",
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
      },
      skillsContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: "12px",
      },
      showMoreButton: {
        marginTop: "17px",
        borderRadius: "4px",
      },
    },

    skillMeter: {
      container: {
        display: "flex",
        flexDirection: "column",
        rowGap: "6px",
      },
      header: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-end",
      },
      skillName: {
        color: "var(--Dark---1000, #111)",
        fontFamily: "Montserrat",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "18px",
      },
      percentage: {
        color: "var(--Dark---1000, #111)",
        fontFeatureSettings: "liga off, clig off",
        fontFamily: "Montserrat",
        fontSize: "10px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "normal",
      },
      progressBar: {
        height: "16px",
        borderRadius: "4px",
        backgroundColor: "#E0E0E0",
        "& .MuiLinearProgress-bar": {
          background: "linear-gradient(270deg, #039103 0%, rgba(3, 145, 3, 0.60) 100%)",
        },
      },
    },

    slider: {
      container: {
        position: "relative",
        height: "520px",
      },
      mediaContainer: {
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#000",
      },
      media: {
        width: "100%",
        height: "100%",
      },
      navigationButton: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 10,
        border: "none",
        background: "#FFF !important",
      },
      paginationContainer: {
        position: "absolute",
        bottom: "60px",
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        gap: 1,
        zIndex: 10,
      },
      paginationDot: (isActive: boolean) => ({
        width: 8,
        height: 8,
        borderRadius: "50%",
        cursor: "pointer",
        backgroundColor: isActive ? "#076D0D" : "#FFF",
        transition: "background-color 0.3s",
      }),
    },
  },
};
